import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=bcfa91ea&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcfa91ea')) {
      api.createRecord('bcfa91ea', component.options)
    } else {
      api.reload('bcfa91ea', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=bcfa91ea&", function () {
      api.rerender('bcfa91ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26mCb7bH5dRMd/JS/comp/IncreaseNumber.vue"
export default component.exports